<template>
  <el-carousel :height="mobileDevice"
               :arrow="hideArrow">
    <el-carousel-item>
      <div class="bg"
           :style="{backgroundImage: `url('${images[0]}')` }"></div>
      <div class="header_box">
        <div class="header_title">
          <span>
            <img class="left"
                 src="@/assets/icon/arrowLeft.png">
            <img class="right"
                 src="@/assets/icon/arrowRight.png">
            {{$t('home.title1')}}
          </span>
        </div>
        <div class="header_content">{{$t('home.introduce1')}}</div>
      </div>
    </el-carousel-item>
    <el-carousel-item>
      <div class="bg"
           :style="{backgroundImage: `url('${images[1]}')` }"></div>
      <div class="header_box">
        <div class="header_title">
          <span>
            <img class="left"
                 src="@/assets/icon/arrowLeft.png">
            <img class="right"
                 src="@/assets/icon/arrowRight.png">
            {{$t('home.title2')}}
          </span>
        </div>
        <div class="header_content">{{$t('home.introduce2')}}</div>
      </div>
    </el-carousel-item>
    <el-carousel-item>
      <div class="bg"
           :style="{backgroundImage: `url('${images[2]}')` }"></div>
      <div class="header_box">
        <div class="header_title">
          <span>
            <img class="left"
                 src="@/assets/icon/arrowLeft.png">
            <img class="right"
                 src="@/assets/icon/arrowRight.png">
            {{$t('home.title3')}}
          </span>
        </div>
        <div class="header_content">{{$t('home.introduce3')}}</div>
      </div>
    </el-carousel-item>
  </el-carousel>
</template>

<script>
import headerImg1 from '@/assets/images/header_img1.png'
import headerImg2 from '@/assets/images/header_img2.png'
import headerImg3 from '@/assets/images/header_img3.png'

export default {
  computed: {
    mobileDevice: {
      get() {
        return this.$store.state.mobileDevice ? '7.5rem' : '100vh'
      }
    },
    hideArrow: {
      get() {
        return this.$store.state.mobileDevice ? 'never' : 'always'
      }
    }
  },
  data() {
    return {
      images: [headerImg1, headerImg2, headerImg3]
    }
  },
  methods: {
    // callback(value) {
    //   this.$emit('change', value)
    // }
  }
}
</script>

<style lang="scss" scoped>
.el-carousel {
  overflow: hidden;
  .bg {
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-attachment: local;
    width: 100%;
    height: 100%;
  }
  /deep/.el-carousel__arrow {
    background-color: rgba(31, 45, 61, 0);
    height: 0.76rem;
    width: 0.76rem;
    i {
      font-size: 0.36rem;
    }

    &:hover {
      background-color: #069dcc;
    }
  }

  .header_box {
    position: absolute;
    z-index: 10;
    width: 50%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    // transform: translateY(-50%);
    .header_title {
      font-size: 0.46rem;
      line-height: 0.69rem;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      text-align: center;
      padding: 0.2rem 0rem;
      span {
        position: relative;
        padding: 0.2rem 0rem;
        display: inline-block;
        img {
          display: inline-block;
          position: absolute;
          width: 0.31rem;
        }

        .left {
          top: 0px;
          left: 0px;
          transform: translateX(-80%);
        }
        .right {
          bottom: 0px;
          right: 0px;
          transform: translateX(80%);
        }
      }
    }

    .header_content {
      font-size: 0.2rem;
      line-height: 0.26rem;
      font-family: "Chinese Quote", -apple-system, BlinkMacSystemFont,
        "Segoe UI", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",
        "Helvetica Neue", Helvetica, Arial, sans-serif, "Apple Color Emoji",
        "Segoe UI Emoji", "Segoe UI Symbol";
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      text-align: center;
      margin: 0.1rem 0rem;
    }
  }

  @media only screen and (max-width: 750px) {
    .header_box {
      width: 80%;
      .header_title {
        font-size: 0.37rem;
      }
    }
  }
}
</style>
